export const categories = [
    "Culture and Free Time",
    "Digital Wellbeing",
    "Make Your Voice Heard",
    "Who are you",
    "Life Skills",
    "Money Matters",
    "Exam Revision",
    "Careers & Options",
    "Relationships"
];


export const careerOptions = [
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    }
];



 export const groupMapping = {
  1: {
    label: "KS2 Lower",
    options: [
      { value: "3", label: "Year 3" },
      { value: "4", label: "Year 4" },
    ],
  },
  2: {
    label: "KS2 Higher",
    options: [
      { value: "5", label: "Year 5" },
      { value: "6", label: "Year 6" },
    ],
  },
  3: {
    label: "KS3",
    options: [
      { value: "7", label: "Year 7" },
      { value: "8", label: "Year 8" },
      { value: "9", label: "Year 9" },
    ],
  },
  4: {
    label: "KS4",
    options: [
      { value: "10", label: "Year 10" },
      { value: "11", label: "Year 11" },
    ],
  },
  14: {
    label: "College",
    options: [
      { value: "14", label: "College (1st Year)" },
      { value: "15", label: "College (2nd Year)" },
    ],
  },
  18: {
    label: "Post-18",
    options: [{ value: "18", label: "Post-18" }],
  },
};



export const  groupData= [


    {"id": 1, "name": "KS2 Lower"},
    {"id": 2, "name": "KS2 Higher"},
    {"id": 3, "name": "KS3"},
    {"id": 4, "name": "KS4"},
    {"id": 14, "name": "College"},
    {"id": 18, "name": "Post-18"},








]



export const  YearData= [
    {"value": 3, "name": "Year 3"},
    {"value": 4, "name": "Year 4"},
    {"value": 5, "name": "Year 5"},
    {"value": 6, "name": "Year 6"},

    {"value": 7, "name": "Year 7"},
    {"value": 8, "name": "Year 8"},
    {"value": 9, "name": "Year 9"},
    {"value": 10, "name": "Year 10"},
    {"value": 11, "name": "Year 11"},
    {"value": 14, "name": "College (1st Year)"},
    {"value": 15, "name": "College (2nd Year)"},
    {"value": 18, "name": "Post-18"},
]


export const YearDataNew = [

  { id: 1, value: 3, name: "Year 3" },
  { id: 1, value: 4, name: "Year 4" },


  { id: 2, value: 5, name: "Year 5" },
  { id: 2, value: 6, name: "Year 6" },


  { id: 3, value: 7, name: "Year 7" },
  { id: 3, value: 8, name: "Year 8" },
  { id: 3, value: 9, name: "Year 9" },


  { id: 5, value: 10, name: "Year 10" },
  { id: 5, value: 11, name: "Year 11" },


  { id: 14, value: 14, name: "College (1st Year)" },
  { id: 14, value: 15, name: "College (2nd Year)" },
  { id: 18, value: 18, name: "Post-18" },
];




export const NodataChart = [
    { day: "Monday", hours: 0},
    { day: "Tuesday", hours: 0 },
    { day: "Wednesday", hours: 0 },
    { day: "Thursday", hours: 0 },
    { day: "Friday", hours: 0 },
    { day: "Saturday", hours: 0},
    { day: "Sunday", hours: 0},
  ];


export const issueTypeData = [
    { type: "Login problems" },
    { type: "Account settings errors" },
    { type: "Video playback errors" },
    { type: "Sensitive video" },
    { type: "App crashes or freezes" },
    { type: "Connectivity problems" },
    { type: "General feedback" },
    { type: "Suggestions for improvement" },
    { type: "Other" }
  ];


export const GENDER_TYPE = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer Not to Say" },
];
  

export const dropdownGroupsDashboard = [
  {
    group: 1,
    label: "KS2 Lower",
    years: [
      { value: 3, name: "Year 3" },
      { value: 4, name: "Year 4" },
    ],
  },
  {
    group: 2,
    label: "KS2 Higher",
    years: [
      { value: 5, name: "Year 5" },
      { value: 6, name: "Year 6" },
    ],
  },
  {
    group: 3,
    label: "KS3",
    years: [
      { value: 7, name: "Year 7" },
      { value: 8, name: "Year 8" },
      { value: 9, name: "Year 9" },
    ],
  },
  {
    group: 4,
    label: "KS4",
    years: [
      { value: 10, name: "Year 10" },
      { value: 11, name: "Year 11" },
    ],
  },
  {
    group: 14,
    label: "College",
    years: [
      { value: 14, name: "College (1st Year)" },
      { value: 15, name: "College (2nd Year)" },
    ],
  },
  {
    group: 18,
    label: "Post-18",
    years: [{ value: 18, name: "Post-18" }],
  },
];

export const YEAR_GROUP_DISPLAY_MAP = {
  1: "Year 1",
  2: "Year 2",
  3: "Year 3",
  4: "Year 4",
  5: "Year 5",
  6: "Year 6",
  7: "Year 7",
  8: "Year 8",
  9: "Year 9",
  10: "Year 10",
  11: "Year 11",
  12: "College (1st Year)",
  13: "College (2nd Year)",
  14: "College (1st Year)",
  15: "College (2nd Year)",
  16: "Post-18",
  17: "Post-18",
  18: "Post-18",
};

export const getYearGroupLabel = (year) => {
  if (year === null || year === undefined || year === "" || year === 0 || year === "0") {
    return "";
  }

  const strVal = String(year).trim();
  if (
    !strVal ||
    strVal === "0" ||
    strVal.toLowerCase() === "n/a" ||
    strVal.toLowerCase() === "null" ||
    strVal.toLowerCase() === "undefined"
  ) {
    return "";
  }

  const lower = strVal.toLowerCase();
  if (lower === "college" || lower === "year 14") {
    return "College (2nd Year)";
  }
  if (lower.includes("college") && (lower.includes("1st") || lower.includes("1"))) {
    return "College (1st Year)";
  }
  if (lower.includes("college") && (lower.includes("2nd") || lower.includes("2"))) {
    return "College (2nd Year)";
  }
  if (
    lower.includes("post-18") ||
    lower.includes("post - 18") ||
    lower.includes("post 18") ||
    lower.includes("post18") ||
    lower.includes("post_18")
  ) {
    return "Post-18";
  }

  const num = parseInt(strVal, 10);
  if (!isNaN(num)) {
    if (num >= 1 && num <= 11) {
      return `Year ${num}`;
    }
    if (num === 12 || num === 14) {
      return "College (1st Year)";
    }
    if (num === 13 || num === 15) {
      return "College (2nd Year)";
    }
    if (num >= 16) {
      return "Post-18";
    }
  }

  if (strVal.startsWith("Year ")) {
    const parsedNum = parseInt(strVal.replace("Year ", ""), 10);
    if (!isNaN(parsedNum)) {
      return getYearGroupLabel(parsedNum);
    }
  }

  return strVal;
};

